const ModelStateErrors = (window.MODEL_STATE_ERRORS || {}).errors || [];
const OrderInfo = window.ORDER_INFO || {};
const UrlBundles = window.URL_BUNDLES || {};
const UserInfo = window.USER_INFO || {};
const VehicleInfo = window.VEHICLE_INFO || {};
const RiderInfo = window.RIDER_INFO || {};
import { Interceptor, EventHub } from "./interceptor";
import * as Prototypes from "./prototypes";

export { EventHub, Interceptor, ModelStateErrors, OrderInfo, Prototypes, UrlBundles, UserInfo, VehicleInfo, RiderInfo };
